import type { ReactNode } from 'react';
import { TopBar } from './TopBar';
import { RailLeft } from './RailLeft';
import { RailRight } from './RailRight';
import { ImpersonateBanner } from './ImpersonateBanner';

export function Shell({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-dvh bg-bg">
      <TopBar />
      <ImpersonateBanner />
      <div className="flex">
        <RailLeft />
        <main className="flex-1 min-w-0 bg-frame">
          <div className="container mx-auto p-4 md:p-6 max-w-7xl">{children}</div>
        </main>
        <RailRight />
      </div>
    </div>
  );
}
